/* GG · Global · Announcement — cross-fade rotator with pause.
   Respects prefers-reduced-motion (no auto-rotate) and pauses on hover. */
(function () {
  'use strict';

  function initOne(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-gg-announce-item]'));
    if (items.length < 2) return;

    var toggle = root.querySelector('[data-gg-announce-toggle]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wrap = root.closest('.gg-announce-wrap');
    var interval = 5000;
    if (wrap) {
      var v = getComputedStyle(wrap).getPropertyValue('--gg-announce-interval');
      var parsed = parseInt(v, 10);
      if (!isNaN(parsed)) interval = parsed;
    }

    var current = 0;
    var timer = null;
    var paused = reduced; // start paused if reduced motion

    function show(next) {
      items[current].classList.remove('is-active');
      items[current].setAttribute('aria-hidden', 'true');
      current = (next + items.length) % items.length;
      items[current].classList.add('is-active');
      items[current].removeAttribute('aria-hidden');
    }

    function start() {
      if (paused || timer) return;
      timer = setInterval(function () { show(current + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function setPaused(state) {
      paused = state;
      root.classList.toggle('is-paused', paused);
      if (toggle) toggle.setAttribute('aria-pressed', String(paused));
      if (paused) { stop(); } else { start(); }
    }

    if (toggle) {
      toggle.addEventListener('click', function () { setPaused(!paused); });
    }

    // Pause on hover/focus, resume on leave (unless user-paused).
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { if (!paused) start(); });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function () { if (!paused) start(); });

    // Pause when tab hidden.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (!paused) { start(); }
    });

    if (reduced) {
      root.classList.add('is-paused');
      if (toggle) toggle.setAttribute('aria-pressed', 'true');
    } else {
      start();
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-gg-announce]')).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
